module.exports = __webpack_public_path__ + "img/girl-wow-esp.3841993f.jpg";